<template>
    <div class="mx-2 mx-lg-5">
        <div v-if="$store.getters.hasGatehousePerm('add_patrolroute')" class="mb-1 mt-3">
            <button
                class="btn btn-primary btn-sm px-3 py-2 d-flex flex-row justify-content-center align-items-center"
                @click="addPatrol"
            >
                <icon icon="Plus"></icon>
                <span class="ms-2 fs-6 fw-bold">{{ $t("patrolRoute.new") }}</span>
            </button>
        </div>
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.patrolRoutes") }}</h3>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("patrolRoute.name") }}</th>
                            <th>{{ $t("patrolRoute.frequencyMinutes") }}</th>
                            <th>{{ $t("patrolRoute.startedAt") }}</th>
                            <th>{{ $t("patrolRoute.finishedAt") }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="patrolRoutes.length">
                        <tr
                            v-for="patrol in paginatedRoutes"
                            :key="patrol.id"
                            class="align-middle"
                        >
                            <td>{{ patrol.name }}</td>
                            <td>{{ patrol.frequency_minutes }} min</td>
                            <td>{{ patrol.started_at ? patrol.started_at.slice(0, 5) : "--" }}</td>
                            <td>{{ patrol.finished_at ? patrol.finished_at.slice(0, 5) : "--" }}</td>
                            <td>
                                <button
                                    class="btn btn-primary btn-sm me-2"
                                    @click="goToDetail(patrol)"
                                >
                                    <icon icon="Search"></icon>
                                </button>
                                <button
                                    v-if="$store.getters.hasGatehousePerm('change_patrollog')"
                                    class="btn btn-secondary btn-sm me-2"
                                    @click="editRoute(patrol.id)"
                                >
                                    <icon icon="EditPen"></icon>
                                </button>
                                <button
                                    v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                                    class="btn btn-danger btn-sm"
                                    @click="deleteRoute(patrol)"
                                >
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center text-muted py-3">
                                {{ $t("patrolRoute.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="patrolRoutes.length >= 5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    data() {
        return {
            patrolRoutes: [],
            currentPage: 1,
            perPage: 10,
        }
    },
    computed: {
        paginatedRoutes() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.patrolRoutes.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.patrolRoutes.length / this.perPage);
        }
    },
    created() {
        this.getPatrolRoutes();
    },
    methods: {
        getPatrolRoutes() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/patrols`)
            .then(response => {
                this.patrolRoutes = response.data;
            })
            .catch(error => {
                console.error("Error loading patrol routes.", error);
            });
        },
        goToDetail(patrol) {
            const isAdmin = this.$route.meta.admin;

            this.$router.push({
                name: isAdmin
                    ? "PatrolRouteDetailView_admin"
                    : "PatrolRouteDetailView",
                params: {
                    slug: this.$route.params.slug,
                    id: patrol.id,
                }
            });
        },
        addPatrol() {
            const isAdmin = this.$route.meta.admin;

            this.$router.push({
                name: isAdmin
                    ? "PatrolRouteAddView_admin"
                    : "PatrolRouteAddView",
                params: {
                    slug: this.$route.params.slug
                }
            })
        },
        editRoute(patrolId) {
            const isAdmin = this.$route.meta.admin;

            this.$router.push({
                name: isAdmin
                    ? "PatrolRouteEditView_admin"
                    : "PatrolRouteEditView",
                params: {
                    slug: this.$route.params.slug,
                    id: patrolId,
                }
            });
        },
        deleteRoute(patrol) {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: patrol.name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/patrols/${patrol.id}/delete`)
            .then(() => {
                this.getPatrolRoutes();
            })
            .catch(error => {
                console.error("Error deleting patrol route.", error);
            });
        }
    }
}
</script>